<mat-drawer-container class="example-container">
  <mat-drawer mode="side" opened class="sidenav mat-elevation-z8">
    <div class="d-flex justify-content-center p-4">
      <img src="../../../assets/images/default-user-example.jpg" alt="" class="profile-image">
    </div>
    <div class="sidenav-list">
      <div class="sidenav-item" *ngFor="let item of sidenavLinks" [routerLink]="[item.url]" [matTooltip]="item.name"
        matTooltipPosition="right">
        <div class="rounded-circle dv-menu">
          <span>
            {{item.name.substring(0,1)}}
          </span>
        </div>
      </div>
    </div>
    <div class="logout" matTooltip="Cerrar sesión">
      <img (click)="logout()" src="../../../assets/images/icons/logout.svg" alt="">
    </div>
    <div class="text-center">
      <div class="pt-2 version">v0.56.04</div>
    </div>
  </mat-drawer>
  <mat-drawer-content class="main-content">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
